export const LOGIN_ROUTE = '/login'
export const MAIN_ROUTE = '/main'
export const DRAGON_ROUTE = '/dragon'
export const PROFILE_ROUTE = '/profile'





